import { useState } from "react";
import useInstallPrompt from "../lib/useInstallPrompt";

/**
 * A sleek, dismissible banner that invites users to install the PWA.
 * Only renders when the browser offers a native install prompt.
 */
export default function InstallBanner() {
  const { canInstall, install } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(false);

  if (!canInstall || dismissed) return null;

  return (
    <div className="fixed bottom-[calc(var(--bottom-tab-height,0px)+1rem)] md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:w-[360px] z-50 animate-slide-up">
      <div className="bg-surface-overlay border border-edge rounded-2xl shadow-xl p-4 flex items-start gap-3">
        {/* Icon */}
        <div className="shrink-0 h-10 w-10 rounded-xl bg-brand-subtle text-brand grid place-items-center">
          <span className="material-symbols-outlined text-[22px]">
            install_mobile
          </span>
        </div>

        {/* Copy */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-ink leading-tight">
            Install JustTrackIt
          </p>
          <p className="text-xs text-ink-muted mt-0.5">
            Add to your home screen for a faster, app-like experience.
          </p>

          {/* Actions */}
          <div className="flex items-center gap-2 mt-2.5">
            <button
              type="button"
              onClick={install}
              className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-xs font-semibold bg-brand text-brand-contrast hover:bg-brand/90 transition-colors"
            >
              <span className="material-symbols-outlined text-[16px]">
                download
              </span>
              Install
            </button>
            <button
              type="button"
              onClick={() => setDismissed(true)}
              className="px-3 py-1.5 rounded-lg text-xs font-medium text-ink-muted hover:text-ink hover:bg-surface-raised transition-colors"
            >
              Not now
            </button>
          </div>
        </div>

        {/* Close */}
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="shrink-0 p-1 rounded-lg text-ink-muted hover:text-ink hover:bg-surface-raised transition-colors"
          aria-label="Dismiss install banner"
        >
          <span className="material-symbols-outlined text-[18px]">close</span>
        </button>
      </div>
    </div>
  );
}
